import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ISubscriptionsPlusState } from "./subscriptions-plus.state";

export const selectSubscriptionsPlusState = createFeatureSelector<ISubscriptionsPlusState>('subscriptionsPlus');

export const selectLicenses = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.licenses
);

export const selectLicenseItems = createSelector(
    selectLicenses, (licenses) => licenses.items
);

export const selectLicensesLoading = createSelector(
    selectLicenses, (licenses) => licenses.loading
);

export const selectLicensesError = createSelector(
    selectLicenses, (licenses) => licenses.error
);

export const selectSelectedLicense = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.selectedLicense
);

export const selectDistribution = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.distribution
);

export const selectTransition = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.transition
);

export const selectUsageByLicenseId = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.usage.byLicenseId
);

export const selectLicenseUsageEntry = (licenseId: string) => createSelector(
    selectUsageByLicenseId,
    (byLicenseId) => byLicenseId[licenseId] ?? null
);

export const selectLicenseLinks = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.licenseLinks
);

export const selectLinkManagement = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.linkManagement
);

export const selectIncludeChildren = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.includeChildren
);

export const selectGlobalLinks = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.globalLinks
);

export const selectLinksOverview = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.linksOverview
);

export const selectLinkEntity = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.linkEntity
);

export const selectLicenseNotes = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.notes
);

export const selectNoteCreate = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.noteCreate
);

export const selectNoteDelete = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.noteDelete
);

export const selectBulkEdit = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.bulkEdit
);

export const selectChildOrganisations = createSelector(
    selectSubscriptionsPlusState,
    (state: ISubscriptionsPlusState) => state.childOrganisations
);

export const selectChildOrganisationItems = createSelector(
    selectChildOrganisations,
    (childOrgs) => childOrgs.items
);
